export default {
  // 頁面標題
  title: "監控動態",

  // 篩選條件
  transactionDirection: "交易方向",
  inputCounterpartyAddress: "請輸入交易對手地址",
  minAmount: "最小金額",
  maxAmount: "最大金額",
  maxAmountTip: "最大金額需≥最小金額",

  // 交易方向選項
  outflow: "流出",
  inflow: "流入",
  bidirectional: "雙向",

  // 按鈕
  reset: "重置",
  query: "查詢",

  // 統計信息
  currentChain: "當前地址所屬鏈：",
  totalCount: "共",
  totalDynamics: "條監控動態",
  unread: "條未讀",
  markAllRead: "全部標為已讀",

  // 表格列
  transactionTime: "交易時間",
  sender: "發送方",
  receiver: "接收方",
  currency: "幣種",
  transactionQuantity: "交易數量",
  transactionHash: "交易哈希",
  operation: "操作",

  // 地址
  currentAddress: "當前地址",

  // 操作按鈕
  markRead: "已讀",
  addToMonitor: "加入監控",
  addToCanvas: "加入畫布",

  // 對話框
  dialogAddMonitor: "添加監控",
  monitorAddSuccess: "地址監控添加成功",
  return: "返回",
  viewMonitor: "查看監控",

  // 提示信息
  loading: "拼命加載中",
  noData: "暫無數據",
  copySuccess: "複製成功",
};
